import { render, staticRenderFns } from "./NewProductList.vue?vue&type=template&id=19e0808d&scoped=true"
import script from "./NewProductList.vue?vue&type=script&lang=js"
export * from "./NewProductList.vue?vue&type=script&lang=js"
import style0 from "./NewProductList.vue?vue&type=style&index=0&id=19e0808d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e0808d",
  null
  
)

export default component.exports